import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdCloudDownload, MdEmojiEvents, MdPeople, MdSettings } from 'react-icons/md';

const adminLinks = [
    { to: '/admin', label: 'Uživatelé', icon: <MdPeople className="text-[18px]" />, end: true },
    { to: '/admin/tournaments', label: 'Turnaje', icon: <MdEmojiEvents className="text-[18px]" />, end: false },
    { to: '/admin/settings', label: 'Nastavení', icon: <MdSettings className="text-[18px]" />, end: false },
    { to: '/admin/import', label: 'Import dat', icon: <MdCloudDownload className="text-[18px]" />, end: false },
];

export function AdminSubmenu() {
    return (
        <div className="bg-bg-card border-b border-border-neutral shadow-row">
            <nav className="max-w-7xl mx-auto px-4 md:px-8 flex items-center gap-2 overflow-x-auto scrollbar-thin">
                {adminLinks.map(link => (
                    <NavLink
                        key={link.to}
                        to={link.to}
                        end={link.end}
                        className={({ isActive }) => [
                            'h-12 px-3 flex items-center gap-2 border-b-[3px] text-[14px] font-bold font-nunito whitespace-nowrap transition-colors',
                            isActive
                                ? 'border-brand-blue text-brand-blue'
                                : 'border-transparent text-text-muted hover:text-text-primary',
                        ].join(' ')}
                    >
                        {link.icon}
                        {link.label}
                    </NavLink>
                ))}
            </nav>
        </div>
    );
}
